import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class FlightReportsAvailabilities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      totals: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            aircraft_models_select: responseJson.data.aircraft_models_select,
            bases_select: responseJson.data.bases_select,
            flight_types_select: responseJson.data.flight_types_select,
            clients_select: responseJson.data.clients_select,
            receits_select: responseJson.data.receits_select,
            staffs_select: responseJson.data.staffs_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      aircraft_id: this.state.aircraft_id,
      contract_id: this.state.contract_id,
      contract_base_id: this.state.contract_base_id,
      status: this.state.status,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/boletim/disponibilidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.main, totals: responseJson.data.totals, headers: responseJson.data.headers, searched: 1});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    var columns = null

    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.DataInicial}:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" required />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.DataFinal}:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.Contrato}:</label>
            <Select
              className=""
              name="contract_id"
              value={this.state.contract_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_id')}
              options={this.state.clients_select}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.SomenteAprovados}:</label>
            <Select
              className=""
              name="status"
              value={this.state.status}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'status')}
              options={[
                {value: 1, label: this.locale.general.sim},
                {value: 0, label: this.locale.general.nao},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.BaseContratual}:</label>
            <Select
              className=""
              name="contract_base_id"
              value={this.state.contract_base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_base_id')}
              options={this.state.bases_select}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      {self.state.searched === 1 &&
          <div>
            <hr/>
            <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
              <TableHeaderColumn dataField={'contract'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.PrefixoContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'backup_aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.Backup}</TableHeaderColumn>
              <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='135'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.Data}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract_type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoDeContrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_landing'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooDecolagemAoPouso}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engines'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooPartidaAoCorte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'landing'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.QtdPousos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'starts'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.QtdPartidas}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_landing_total_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooTotalDecolagemAoPouso}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_landing_average_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DuracaoMediaDeVooDecolagemAoPouso}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engines_total_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooTotalPartidaAoCorte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engines_average_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DuracaoMediaDeVooPartidaAoCorte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.MaximoDeDisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_total_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.IndisponibilidadeReal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_contractual_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.IndisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'availability_total_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DisponibilidadeReal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'availability_contractual_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_mprg_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoMPRG}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_mnpr_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoMNPR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_ops_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoOPS}</TableHeaderColumn>
              <TableHeaderColumn dataField={'abnormal_ocurrences'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.OcorrenciaAnormal}</TableHeaderColumn>
            </BootstrapTable>
            <hr/>
            <h4 className="page-title">{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tituloTotais}</h4>
            <hr/>
            <BootstrapTable data={this.state.totals} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
              <TableHeaderColumn dataField={'contract'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='180'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PrefixoContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'backup_aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.Backup}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract_type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoDeContrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'landing'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.QtdPousos}</TableHeaderColumn>
              <TableHeaderColumn dataField={'starts'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.QtdPartidas}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_landing_total_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.VooTotalDecolagemAoPouso}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engines_total_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.VooTotalPartidaAoCorte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'takeoff_landing_average_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DuracaoMediaDeVooDecolagemAoPouso}</TableHeaderColumn>
              <TableHeaderColumn dataField={'engines_average_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DuracaoMediaDeVooPartidaAoCorte}</TableHeaderColumn>
              <TableHeaderColumn dataField={'total_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TempoTotalRegistrado}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract_time'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.MaximoDeDisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_total_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.IndisponibilidadeReal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_contractual_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.IndisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'availability_total_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DisponibilidadeReal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'availability_contractual_time_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_mprg_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoMPRG}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_mnpr_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoMNPR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_ops_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoOPS}</TableHeaderColumn>
              <TableHeaderColumn dataField={'abnormal_ocurrences'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.OcorrenciaAnormal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_total_time_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemIndisponibilidadeReal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_contractual_time_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemIndisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'availability_total_time_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemDisponibilidadeReal}</TableHeaderColumn>
              <TableHeaderColumn dataField={'availability_contractual_time_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemDisponibilidadeContratual}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_mprg_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemTipoMPRG}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_mnpr_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemTipoMNPR}</TableHeaderColumn>
              <TableHeaderColumn dataField={'interruption_ops_percent'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemTipoOPS}</TableHeaderColumn>
              <TableHeaderColumn dataField={'utilization_takeoff_landing'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemAproveitamentoDecolagemAoPouso}</TableHeaderColumn>
              <TableHeaderColumn dataField={'utilization_total'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='130'>{this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemAproveitamentoPartidaAoCorte}</TableHeaderColumn>
            </BootstrapTable>
          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportsAvailabilities;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/FlightReportsAvailabilities.js